export default __webpack_public_path__ + "static/media/close-menu.6ada721b.svg";